import axios from 'axios'
import { axiosResponseInterceptorError, axiosRequestInterceptResponse } from '@/util/axios-intercept'

const instanceGenerator = (baseUrl) => {
  const instance = axios.create({
    baseURL: `${baseUrl}${localStorage.getItem('lang')}`
  })

  instance.interceptors.request.use(
    axiosRequestInterceptResponse,
    (error) => Promise.reject(error)
  )

  instance.interceptors.response.use(
    (response) => response,
    axiosResponseInterceptorError
  )
  return instance
}

// export const axiosBaseURL = instanceGenerator(process.env.VUE_APP_URL)
// console.log(process.env.VUE_APP_URL, 'process.env.VUE_APP_URL')
export const axiosInstance = instanceGenerator(process.env.VUE_APP_URL)
